import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ContactInfo {
  phone: string;
  email: string;
  address: string;
  maps_embed_url?: string;
}

export interface HoursEntry {
  label: string;
  hours: string;
}

export function useSiteSettings<T>(key: string) {
  return useQuery({
    queryKey: ["site-settings", key],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("setting_value")
        .eq("setting_key", key)
        .single();
      if (error) throw error;
      return data.setting_value as T;
    },
    staleTime: 1000 * 60 * 5,
  });
}
